import { ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useIndicateurTdbStore } from './useIndicateurTdbStore'
import { storeToRefs } from 'pinia'

export function useIndicateurTdbScroll() {
  const containerRef = ref<HTMLElement | null>(null)
  const currentPage = ref(0)
  const showDots = ref(false)
  const store = useIndicateurTdbStore()
  const { authorizedDocumentCards } = storeToRefs(store)

  const CARDS_PER_STEP = 2

  function getCardCount() {
    return Object.keys(authorizedDocumentCards.value).length
  }

  const pageCount = computed(() => Math.ceil(getCardCount() / CARDS_PER_STEP))

  function checkScrollPossible() {
    nextTick(() => {
      const el = containerRef.value
      if (!el) return
      showDots.value = el.scrollWidth > el.clientWidth
    })
  }

  function onScroll() {
    const el = containerRef.value
    if (!el) return
    const maxScroll = el.scrollWidth - el.clientWidth
    if (maxScroll <= 0) return
    const scrollRatio = el.scrollLeft / maxScroll
    currentPage.value = Math.round(scrollRatio * (pageCount.value - 1))
  }

  function scrollToPage(page: number) {
    const el = containerRef.value
    if (!el) return
    const maxScroll = el.scrollWidth - el.clientWidth
    if (maxScroll <= 0) return
    const targetScroll = pageCount.value <= 1 ? 0 : (page / (pageCount.value - 1)) * maxScroll
    el.scrollTo({ left: targetScroll, behavior: 'smooth' })
  }

  onMounted(() => {
    window.addEventListener('resize', checkScrollPossible)
    checkScrollPossible()
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkScrollPossible)
  })

  watch(authorizedDocumentCards, checkScrollPossible, { deep: true })

  return {
    containerRef,
    currentPage,
    pageCount,
    showDots,
    onScroll,
    scrollToPage,
    checkScrollPossible,
  }
}
